import React, { useState } from 'react';
import styles from './LoginEmailPassword.module.scss';
import { TextInput } from '@/components/common/TextInput/TextInput';
import { useUser } from '@/hooks';
import { validateUtils } from '@/utils/helpers/validation';
import { ERROR_CODES_FIREBASE } from '@/constants/integrations/firebase';
import { INPUT_TYPE } from '@/constants/ui/input';
import { t } from 'i18next';
import {
  Button,
  EButtonHierarchy,
  EButtonSize,
} from '@/components/common/Button/Button';
import { Trans } from 'react-i18next';

interface ILoginEmailPasswordProps {
  onLoginSuccess: () => void;
  source: string;
}
export const LoginEmailPassword: React.FC<ILoginEmailPasswordProps> = (
  props: ILoginEmailPasswordProps
) => {
  const userHook = useUser();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');

  const checkValidation = (): boolean => {
    setEmailError('');
    setPasswordError('');
    if (!email) {
      setEmailError(t('validation.email.required'));
      return false;
    }
    if (!validateUtils.validateEmail(email)) {
      setEmailError(t('validation.email.invalid'));
      return false;
    }
    if (!password) {
      setPasswordError(t('validation.password.required'));
      return false;
    }
    if (!validateUtils.validatePassword(password)) {
      setPasswordError(t('validation.password.invalid'));
      return false;
    }
    return true;
  };

  const handleLogin = async () => {
    if (!checkValidation()) {
      return;
    }
    try {
      await userHook.signInWithEmailPassword(email, password, props.source);
      props.onLoginSuccess();
    } catch (e: any) {
      if (e.code === ERROR_CODES_FIREBASE.EMAIL_NOT_FOUND) {
        setEmailError(t('validation.email.notFound'));
      }
      if (e.code === ERROR_CODES_FIREBASE.WRONG_PASSWORD) {
        setPasswordError(t('validation.password.wrong'));
      }
    }
  };
  return (
    <div className={styles.loginEmailPassword}>
      <div className={styles.formWrapper}>
        <TextInput
          type={INPUT_TYPE.EMAIL}
          placeholder={t('login.placeholders.email')}
          value={email}
          onChange={setEmail}
          error={emailError}
          onEnter={handleLogin}
        />
        <TextInput
          type={INPUT_TYPE.PASSWORD}
          placeholder={t('login.placeholders.password')}
          value={password}
          onChange={setPassword}
          error={passwordError}
          onEnter={handleLogin}
          showPasswordToggle={true}
        />
      </div>
      <Button
        onClick={handleLogin}
        size={EButtonSize.md}
        fillWidth={true}
        hierarchy={EButtonHierarchy.primary}
      >
        <Trans i18nKey={'buttons.continue'} />
      </Button>
    </div>
  );
};
